@if (postLoading$ | async) {
  <app-loading></app-loading>
}

@if (post$ | async; as post) {
  <form class="h-100">
    <div class="url-field">
      <label for="id" sui-label>Post ID</label>
      <div class="url-input-group">
        <sui-input
          type="text"
          id="id"
          [ngModel]="post.id"
          [ngModelOptions]="{ standalone: true }"
          [readonly]="true"
        ></sui-input>
        <sui-button
          variant="secondary"
          [leadingIcon]="['fas', 'copy']"
          (click)="copyToClipboard(post.id)"
          >Copy</sui-button
        >
      </div>
    </div>
    <div class="url-field">
      <label for="story_id" sui-label>Post Story ID</label>
      <div class="url-input-group">
        <sui-input
          type="text"
          id="story_id"
          [ngModel]="post.story_id"
          [ngModelOptions]="{ standalone: true }"
          [readonly]="true"
        ></sui-input>
        <sui-button
          variant="secondary"
          [leadingIcon]="['fas', 'copy']"
          (click)="copyToClipboard(post.story_id)"
          >Copy</sui-button
        >
      </div>
    </div>
    @if (post.author.external_user_id) {
      <div class="url-field">
        <label for="external_user_id" sui-label>External User ID</label>
        <div class="url-input-group">
          <sui-input
            type="text"
            id="external_user_id"
            [ngModel]="post.author.external_user_id"
            [ngModelOptions]="{ standalone: true }"
            [readonly]="true"
          ></sui-input>
          <sui-button
            variant="secondary"
            [leadingIcon]="['fas', 'copy']"
            (click)="copyToClipboard(post.author.external_user_id)"
            >Copy</sui-button
          >
        </div>
      </div>
    }
    <div class="url-field">
      <label for="url" sui-label>Internal URL</label>
      <div class="url-input-group">
        <sui-input
          type="text"
          id="url"
          [ngModel]="postUrlInternal"
          [ngModelOptions]="{ standalone: true }"
          [readonly]="true"
        ></sui-input>
        <sui-button
          variant="secondary"
          [leadingIcon]="['fas', 'copy']"
          (click)="copyToClipboard(postUrlInternal)"
          >Copy</sui-button
        >
        <sui-button
          variant="primary"
          [leadingIcon]="['fas', 'external-link-alt']"
          (click)="openInNewTab(postUrlInternal)"
          >Open</sui-button
        >
      </div>
    </div>
    <div>
      <label for="title" sui-label>Title</label>
      <sui-input
        type="text"
        id="title"
        [ngModel]="post.title"
        [ngModelOptions]="{ standalone: true }"
        [readonly]="true"
      ></sui-input>
    </div>
    <div class="content-wrapper">
      <label for="content" sui-label>{{
        "post-full-content.label.content" | translate
      }}</label>
      <div
        [innerHTML]="post.content"
        class="form-control custom-textarea"
      ></div>
    </div>
  </form>
}
